import { render, staticRenderFns } from "./li_menu_icon.vue?vue&type=template&id=2b92a33a&"
import script from "./li_menu_icon.vue?vue&type=script&lang=js&"
export * from "./li_menu_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b92a33a')) {
      api.createRecord('2b92a33a', component.options)
    } else {
      api.reload('2b92a33a', component.options)
    }
    module.hot.accept("./li_menu_icon.vue?vue&type=template&id=2b92a33a&", function () {
      api.rerender('2b92a33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mailboxer/li_menu_icon.vue"
export default component.exports